import type { ComponentType } from 'react';
import FolderSlider from './FolderSlider';
import FolderSliderContainer, { OwnProps } from './FolderSlider.container';

export default FolderSliderContainer(FolderSlider) as ComponentType<OwnProps>;
